import { useRouter } from 'next/router'
import React from 'react'
import styled from 'styled-components'

import { isString } from 'shared/utils/type-guards'
import { EASING } from '~/common/globalStyles'
import { parsers } from '~/utils/parsers'
import Modal from '~/views/components/ui/Modal'
import Text from '~/views/components/ui/Text'

const VideoWrapper = styled.div<{ show: boolean }>`
  display: block;
  margin: auto auto;
  text-align: center;
  transition: opacity 300ms ${EASING.easeOut};
  opacity: ${({ show }) => (show ? '1' : '0')};
`

interface Props {
  videoUrl?: string | null
}

const VideoModalView: React.FC<Props> = ({ videoUrl }) => {
  const router = useRouter()

  const { showVideo } = router.query

  const closeView = () => router.push('')

  const show = isString(videoUrl) && showVideo === 'true'
  const videoId = isString(videoUrl) ? parsers.youtubeIdParser(videoUrl) : null
  const youtubeLink = `https://www.youtube.com/embed/${videoId}?rel=0&amp;showinfo=0`

  return (
    <Modal show={!!show} onClose={closeView}>
      <VideoWrapper show={!!show}>
        <iframe
          style={{
            height: '75vmin',
            width: '133.35vmin',
            margin: 'auto',
          }}
          title="videoUrl"
          src={youtubeLink}
          frameBorder="0"
          allowFullScreen
        />
        <br />
        <Text color="lightestGray">Click outside to close video</Text>
      </VideoWrapper>
    </Modal>
  )
}

export default VideoModalView
